import { ShippingGroupContainer } from './ShippingGroupContainer';
export default ShippingGroupContainer;
